import { getAllocationTypeLabel } from 'utils';

import {
    ConvictionAllocationType,
    GrowthAllocationType,
    SecuredAllocationType,
    UnmanagedAllocationType,
} from '../_openapi/portfolio-optimizer';

export { getAllocationTypeLabel };

export type AllocationType =
    | GrowthAllocationType
    | SecuredAllocationType
    | ConvictionAllocationType
    | UnmanagedAllocationType;

export type AllocationTypeParent = {
    label: string;
} & (
    | { allocationType: AllocationType; children?: never }
    | { allocationType?: never; children: AllocationTypeChild[] }
);

export type AllocationTypeChild = {
    label: string;
    allocationType: AllocationType;
};

export const ALLOCATION_TYPES: AllocationTypeParent[] = [
    {
        label: getAllocationTypeLabel(GrowthAllocationType.US_DIRECT_STOCKS),
        allocationType: GrowthAllocationType.US_DIRECT_STOCKS,
    },
    {
        label: 'Global Beta',
        children: [
            {
                label: getAllocationTypeLabel(GrowthAllocationType.US_EQUITY_ETF),
                allocationType: GrowthAllocationType.US_EQUITY_ETF,
            },
            {
                label: getAllocationTypeLabel(GrowthAllocationType.DEVELOPED_EQUITY_ETF),
                allocationType: GrowthAllocationType.DEVELOPED_EQUITY_ETF,
            },
            {
                label: getAllocationTypeLabel(GrowthAllocationType.EMERGING_EQUITY_ETF),
                allocationType: GrowthAllocationType.EMERGING_EQUITY_ETF,
            },
        ],
    },
    {
        label: getAllocationTypeLabel(GrowthAllocationType.LEVERED_BOND_ETF),
        allocationType: GrowthAllocationType.LEVERED_BOND_ETF,
    },
    {
        label: getAllocationTypeLabel(GrowthAllocationType.CASH_EQUIVALENTS),
        allocationType: GrowthAllocationType.CASH_EQUIVALENTS,
    },
    {
        label: 'Short-Term Treasuries',
        children: [
            {
                label: getAllocationTypeLabel(GrowthAllocationType.SHORT_TERM_TREASURIES_3M),
                allocationType: GrowthAllocationType.SHORT_TERM_TREASURIES_3M,
            },
            {
                label: getAllocationTypeLabel(GrowthAllocationType.SHORT_TERM_TREASURIES_1Y),
                allocationType: GrowthAllocationType.SHORT_TERM_TREASURIES_1Y,
            },
        ],
    },
    {
        label: 'Bond Ladder',
        children: [
            {
                label: getAllocationTypeLabel(GrowthAllocationType.BOND_LADDER_2Y),
                allocationType: GrowthAllocationType.BOND_LADDER_2Y,
            },
            {
                label: getAllocationTypeLabel(GrowthAllocationType.BOND_LADDER_5Y),
                allocationType: GrowthAllocationType.BOND_LADDER_5Y,
            },
            {
                label: getAllocationTypeLabel(GrowthAllocationType.BOND_LADDER_7Y),
                allocationType: GrowthAllocationType.BOND_LADDER_7Y,
            },
            {
                label: getAllocationTypeLabel(GrowthAllocationType.BOND_LADDER_10Y),
                allocationType: GrowthAllocationType.BOND_LADDER_10Y,
            },
            {
                label: getAllocationTypeLabel(GrowthAllocationType.BOND_LADDER_20Y),
                allocationType: GrowthAllocationType.BOND_LADDER_20Y,
            },
            {
                label: getAllocationTypeLabel(GrowthAllocationType.BOND_LADDER_30Y),
                allocationType: GrowthAllocationType.BOND_LADDER_30Y,
            },
        ],
    },
    {
        label: getAllocationTypeLabel(GrowthAllocationType.CUSTOM_ASSET),
        allocationType: GrowthAllocationType.CUSTOM_ASSET,
    },
    {
        label: getAllocationTypeLabel(SecuredAllocationType.PAYDAY_BOND),
        allocationType: SecuredAllocationType.PAYDAY_BOND,
    },
    {
        label: getAllocationTypeLabel(ConvictionAllocationType.CONVICTION),
        allocationType: ConvictionAllocationType.CONVICTION,
    },
    {
        label: getAllocationTypeLabel(GrowthAllocationType.NON_CONFORMING),
        allocationType: GrowthAllocationType.NON_CONFORMING,
    },
];
